export enum TriggerButtonIntent {
  Secondary = "secondary",
  Outlined = "outlined",
  Danger = "danger",
  Active = "active",
}

export enum TriggerButtonSize {
  Normal = "normal",
  Small = "small",
  Mini = "square",
}
